import { differenceInDays, differenceInWeeks } from 'date-fns';
import { firstToLower } from '../utils/string';
import { MonthNames } from '../utils/date';
import { StockStatus } from '../../@types/stock.enum';

const available = [
  'Incoming',
  'Orderable',
  'InStock',
  'InCentralStoreStock',
  'IncomingToCentralStorage',
];

export const isAvailable = (status?: Commerce.StockStatus) =>
  status && available.indexOf(status) >= 0;

export const formatDeliveryDays = (minDays?: number, maxDays = 0) => {
  if (!minDays && minDays !== 0) {
    return null;
  }

  if (minDays === maxDays && minDays <= 10) {
    return `${minDays} ${minDays === 1 ? 'vardag' : 'vardagar'}`;
  } else if (minDays <= 10) {
    return `${minDays}${maxDays ? '-' : ''}${maxDays || ''} ${
      minDays === 1 && !maxDays ? 'vardag' : 'vardagar'
    }`;
  } else if (minDays > 10 && minDays <= 54) {
    return `${Math.ceil(minDays / 5)}-${Math.ceil(minDays / 5) + 1} veckor`;
  }
  return `${Math.round(minDays / 21.75)} månader`;
};

const getIncomingDisplayText = (date?: string) => {
  if (!date) {
    return '';
  }

  const today = new Date();
  const incomingDate = new Date(date);
  const diff = differenceInDays(incomingDate, today);

  if (diff <= 50) {
    return `Åter i butik ${date.substring(0, 10)}`;
  } else if (diff <= 70) {
    const weeks = differenceInWeeks(incomingDate, today);
    return `Åter i butik om ${weeks}-${weeks + 1} veckor`;
  }

  return `Åter i butik i ${firstToLower(MonthNames[incomingDate.getMonth()])}`;
};

interface IDeliveryStore {
  webOrderAvailable: boolean;
}

export const getTextItemDeliveryText = (store?: IDeliveryStore, itemStatus?: IItemStockStatus) => {
  if (!itemStatus || !store) {
    return 'Kan inte hämta lagerstatus för butik';
  }
  switch (itemStatus.status) {
    case StockStatus.Incoming:
      return getIncomingDisplayText(itemStatus.date);

    case StockStatus.InCentralStoreStock:
    case StockStatus.IncomingToCentralStorage:
    case StockStatus.Orderable:
      return (
        (itemStatus.deliveryDays &&
          `Beställningsvara ${formatDeliveryDays(itemStatus.deliveryDays)}`) ||
        ''
      );

    case StockStatus.InStock:
      return `${itemStatus.availableItems} st i lager`;

    case StockStatus.Unavailable:
      return 'Slut i butik';

    case StockStatus.NotFound:
    default:
      return 'Vänligen kontakta butiken för mer information';
  }
};

export const webOrderAvailable = (store?: IDeliveryStore) => {
  return store?.webOrderAvailable || false;
};
